import firebase from 'firebase/app'
import 'firebase/auth'
import publicRoutes from '../router/public'

export const watchAuthChange = store => {
  firebase.auth().onAuthStateChanged(user => {
    store.dispatch('setUser', user)
  })
}

export const watchPageChange = (store, router) => {
  router.beforeResolve((to, from, next) => {
    let alwaysAllow = publicRoutes.includes(to.path)
    if (alwaysAllow)
      return next()

    let user = store.getters.user
    let isExpiredSession = Date.now() >= (user.data.expiration||0)

    if (isExpiredSession) {
      let currentUser = firebase.auth().currentUser
      if (!currentUser)
        return next({ path: '/login' })

      currentUser.getIdToken(/* forceRefresh */ true).then(idToken => {
        store.dispatch('updateSessionToken', {
          idToken: idToken,
          issueTimestamp: Date.now(),
        })
        return next()
      }).catch(error => {
        // this is temporary until we know how best to handle this situation
        /* eslint-disable no-console */
        console.error(error)
        /* eslint-enable no-console */
        return next({ path: '/login' })
      })
    } else {
      return next()
    }
  })
}